/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status__FailedInputs */

const en_payment_status__failed = /** @type {(inputs: Payment_Status__FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Payment_Status__FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const payment_status__failed = /** @type {((inputs?: Payment_Status__FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status__FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_payment_status__failed(inputs)
});